import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { createSelector, StoreModule } from "@ngrx/store";
import { GovernanceEffect } from "./effect";
import { GovernanceReducer } from "./reducer";
import { governanceApprovers } from "../item/store.module";

@NgModule({
  imports: [EffectsModule.forFeature([GovernanceEffect]), StoreModule.forFeature("governance", GovernanceReducer)]
})
export class GovernanceStoreModule {}

export const governanceList = (store: any) => store && store.governance && store.governance.governanceList;
export const governanceByFieldList = (store: any) => store && store.governance && store.governance.governanceByFieldList;
export const governanceById = (store: any) => store && store.governance && store.governance.governanceById;
export const addGovernanceResponse = (store: any) => store && store.governance && store.governance.addGovernanceResponse;
export const updateGovernanceResponse = (store: any) => store && store.governance && store.governance.updateGovernanceResponse;
export const deleteGovernanceResponse = (store: any) => store && store.governance && store.governance.deleteGovernanceResponse;
export const validateStartDateResp = (store: any) => store && store.governance && store.governance.validateStartDateResp;

export const governanceSchemesWithApprovers = createSelector(governanceByFieldList, governanceApprovers, (schemes, approvers) => {
  if (schemes !== null && approvers !== null) {
    return {
      schemes,
      approvers
    };
  }
});
